import cn from 'classnames';
import React, {useState} from 'react';
import PropTypes from 'prop-types';

import s from './index.scss';

const Button = props => {
    const {onClick} = props;
    const [date, setDate] = useState(0);
    return (
        <button
            id={props.id}
            className={cn(s.container, {[s.submit]: props.theme === 'submit'})}
            style={props.style}
            onClick={() => {
                const now = Date.now();
                if (now - date < 2000) {
                    return;
                }
                setDate(now);
                onClick();
            }}
        >
            {props.label}
        </button>
    );
};

Button.propTypes = {
    onClick: PropTypes.func,
    label: PropTypes.any,
}

export default Button;
